var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["header", { mobile: _vm.isMobile(_vm.$mq) }] }, [
    _c("img", {
      staticClass: "llp-img",
      attrs: { src: _vm.learningPath.image }
    }),
    _vm._v(" "),
    _vm.isRecommending
      ? _c("span", { staticClass: "lp-tag" }, [_vm._v(" Your Learning Path ")])
      : _vm._e(),
    _vm._v(" "),
    _c("h2", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.learningPath.short_title))
    ]),
    _vm._v(" "),
    !_vm.hideStats
      ? _c(
          "div",
          { staticClass: "stats" },
          _vm._l(_vm.stats, function(stat) {
            return _c("span", { key: stat.description, staticClass: "stat" }, [
              _vm._v(
                "\n      " +
                  _vm._s(stat.num) +
                  " " +
                  _vm._s(stat.description) +
                  "\n    "
              )
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("p", { staticClass: "description" }, [
      _vm._v(_vm._s(_vm.learningPath.description))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }